export default __webpack_public_path__ + "static/media/funeralDirector.2726d3e2.svg";